import EvaluationStates from '../States/EvaluationStates'
import better_img from '../../assets/img/positivo.png'
import neutral_img from '../../assets/img/neutro.png'
import recoil_img from '../../assets/img/negativo.png'
import withoutChanges_img from '../../assets/img/sin-valores.png'

interface IStatusEvaluation {
    evaluationRight: number | null;
    stateStyleText: string;
    evaluationStateStyleText: string;
    bgColor: string
}

const in_process = 2;
const better = 1;
const neutral = 0;
const recoil = -1;
const withoutChanges = null

const HandleGraph = ({ evaluationRight }: { evaluationRight: number | null }) => {
    const status = evaluationRight;

    if (status === 2 || status === null) {
        return (<img src={withoutChanges_img} alt='Evaluación del derecho' />);
    }

    if (typeof status === 'number') {
        if (status > 0) return (<img src={better_img} alt='Evaluación del derecho' />);
        if (status === 0) return (<img src={neutral_img} alt='Evaluación del derecho' />);
        if (status < 0) return (<img src={recoil_img} alt='Evaluación del derecho' />);
    }

    return null;
}

const TrivalentEvaluation = ({ evaluationRight, stateStyleText, evaluationStateStyleText, bgColor }: IStatusEvaluation) => {
    return (
        <div className='rounded-md w-full h-full flex items-center' style={{ backgroundColor: bgColor }}>
            <div className='p-4 w-full flex justify-between items-center'>
                <div className="flex flex-col w-full items-start">
                    <p className={`${stateStyleText}`}>Estado</p>
                    <EvaluationStates status={evaluationRight} evaluationStateStyleText={evaluationStateStyleText} />
                </div>
                <div className="w-full h-full flex justify-end">
                    <HandleGraph evaluationRight={evaluationRight} />
                </div>
            </div>
        </div>
    )
}

export default TrivalentEvaluation